module.exports = __webpack_public_path__ + "img/google-icon.45651782.png";